import { useState } from "react"
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet"
import { Button } from "@/components/ui/button"
import { Menu } from "lucide-react"
import { SidebarNavigation } from "./SidebarNavigation"
import { SidebarProfile } from "./SidebarProfile"
import { SidebarFooter } from "./SidebarFooter"
import { useQuery } from "@tanstack/react-query"
import { supabase } from "@/integrations/supabase/client"

export function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false)

  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) throw new Error("User not found")

      const { data, error } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", user.id)
        .single()

      if (error) throw error
      return data
    },
  })

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden fixed top-4 left-4 z-50 bg-white/80 backdrop-blur-sm shadow-lg hover:bg-gray-100/80 transition-all duration-300"
        >
          <Menu className="h-6 w-6" />
          <span className="sr-only">Abrir menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="p-0 w-72 fixed top-0 h-full border-r border-primary/10">
        <div className="flex h-full flex-col pt-16">
          <div className="flex-1">
            <SidebarProfile profile={profile} />
            <SidebarNavigation onNavigate={() => setIsOpen(false)} />
          </div>
          <SidebarFooter />
        </div>
      </SheetContent>
    </Sheet>
  )
}